// extracted by mini-css-extract-plugin
module.exports = {"logoDiv":"HighlightLogo_logoDiv__7LoQB","logoText":"HighlightLogo_logoText__yxbvU","logo":"HighlightLogo_logo__bx_mM"};